const CAMPAIGN_DIR = "/diyarUlKhuzama";

const CAMPAIGN_FILENAMES = [
  "WhatsApp Image 2026-08-13 at 14.07.02.jpeg",
  "WhatsApp Image 2026-08-13 at 14.07.03.jpeg",
  "WhatsApp Image 2026-08-13 at 14.07.03 (1).jpeg",
  "WhatsApp Image 2026-08-13 at 14.07.03 (2).jpeg",
  "WhatsApp Image 2026-08-13 at 14.07.03 (3).jpeg",
  "WhatsApp Image 2026-08-13 at 14.07.03 (4).jpeg",
  "WhatsApp Image 2026-08-13 at 14.07.04.jpeg",
  "WhatsApp Image 2026-08-13 at 14.07.04 (1).jpeg",
  "WhatsApp Image 2026-08-13 at 14.07.04 (2).jpeg",
  "WhatsApp Image 2026-08-13 at 14.07.04 (3).jpeg",
  "WhatsApp Image 2026-08-13 at 14.07.05.jpeg",
  "WhatsApp Image 2026-08-13 at 14.07.05 (1).jpeg",
  "WhatsApp Image 2026-08-13 at 14.07.05 (2).jpeg",
  "WhatsApp Image 2026-08-13 at 14.07.05 (3).jpeg",
  "WhatsApp Image 2026-08-13 at 14.07.05 (4).jpeg",
  "WhatsApp Image 2026-08-13 at 14.07.06.jpeg",
  "WhatsApp Image 2026-08-13 at 14.07.06 (1).jpeg",
  "WhatsApp Image 2026-08-13 at 14.07.06 (2).jpeg",
  "WhatsApp Image 2026-08-13 at 14.07.06 (3).jpeg",
  "WhatsApp Image 2026-08-13 at 14.07.07.jpeg",
  "WhatsApp Image 2026-08-13 at 14.07.07 (1).jpeg",
  "WhatsApp Image 2026-08-13 at 14.07.07 (2).jpeg",
  "WhatsApp Image 2026-08-13 at 14.07.07 (3).jpeg",
  "WhatsApp Image 2026-08-13 at 14.07.07 (4).jpeg",
  "WhatsApp Image 2026-08-13 at 14.07.08.jpeg",
];

export const TOTAL_APARTMENTS = 58;

/** Campaign pricing & sizes (full building range). */
export const PRICE_MIN_SAR = 440000;
export const PRICE_MAX_SAR = 470000;
export const AREA_MIN_SQM = 134.96;
export const AREA_MAX_SQM = 163.33;

/** Exact pin from campaign Google Maps directions destination. */
export const MAP_LAT = 26.2308056;
export const MAP_LNG = 50.1923889;
export const MAP_PLACE_NAME = "Diyar Al Khuzama, Al Aziziyah, Al Khobar";

export function campaignMapEmbedUrl() {
  return `https://www.google.com/maps?q=${MAP_LAT},${MAP_LNG}(${encodeURIComponent(MAP_PLACE_NAME)})&ll=${MAP_LAT},${MAP_LNG}&z=13&hl=en&t=m&iwloc=&output=embed`;
}

export function campaignMapPlaceUrl() {
  return `https://www.google.com/maps/search/?api=1&query=${MAP_LAT},${MAP_LNG}`;
}

export function campaignMapDirectionsUrl() {
  return `https://www.google.com/maps/dir/?api=1&destination=${MAP_LAT},${MAP_LNG}`;
}

export function formatCampaignStartingPrice(locale = "en") {
  const formatted = new Intl.NumberFormat(locale === "ar" ? "ar-SA" : "en-US").format(PRICE_MIN_SAR);
  return locale === "ar" ? `${formatted} ر.س` : `SAR ${formatted}`;
}

export function formatCampaignAreaRange(locale = "en") {
  const min = AREA_MIN_SQM.toFixed(2);
  const max = AREA_MAX_SQM.toFixed(2);
  return locale === "ar" ? `${min} – ${max} م²` : `${min} – ${max} m²`;
}

export function campaignImagePath(filename) {
  return `${CAMPAIGN_DIR}/${encodeURIComponent(filename)}`;
}

export const CAMPAIGN_IMAGES = CAMPAIGN_FILENAMES.map(campaignImagePath);

/** Hand-spaced indices — WhatsApp batches often have consecutive near-identical frames. */
export const ABOUT_CAMPAIGN_INDEX = 5;
/** Building exterior first (wide tile); interiors fill the smaller cells. */
export const MOSAIC_CAMPAIGN_INDICES = [23, 1, 9, 17];
export const GALLERY_CAMPAIGN_INDICES = [0, 4, 8, 12, 16, 20, 24, 3, 7, 11, 15, 19, 6, 22];

export function pickAtIndices(images, indices) {
  if (!Array.isArray(images) || !Array.isArray(indices)) return [];
  return indices.map((index) => images[index]).filter(Boolean);
}

export const AMENITY_ICONS = {
  Kitchen: "🍽️",
  "Swimming Pool": "🏊",
  "Fully Equipped Gym": "💪",
  "Games Room": "🎮",
  "Events Hall with its own kitchen": "🎉",
  "Meeting Room": "💼",
  "Private Parking and Smart Access": "🅿️",
  Balcony: "🌅",
  AC: "❄️",
};
